export default __webpack_public_path__ + "645d40659bcdfd4da6b30e5c689b33e1.png";